export class MonthlyDownloadDate {
  productMonth: Date;
  downloadDate: Date;
}
